import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormAnswer } from 'src/app/models/forms/form-answer';

@Component({
  selector: 'choice-form-question',
  templateUrl: './choice-form-question.component.html',
  styleUrls: ['./choice-form-question.component.scss'],
  standalone: false
})
export class ChoiceFormQuestionComponent {
  @Input() public name: string;
  @Input() public possibleAnswers: FormAnswer[];
  @Input() public parentRef: any;
  @Input() public isDisabled: boolean = false;
  @Input() public tooltip: string = null;
  @Input() public questionId: number;
  @Input() public answer: FormAnswer;
  @Input() public disabled?: boolean;

  @Output() public answerChange: EventEmitter<FormAnswer> = new EventEmitter<FormAnswer>();
  @Output() onChange: EventEmitter<FormAnswer> = new EventEmitter<FormAnswer>();

  hasError: boolean = false;
  constructor() { }

  onOptionChange(event: any) {
    this.onChange.emit(event.value);
    this.answerChange.emit(event.value);
  }
}
